<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow': visible }"
    :style="visible ? 'display:block;' : ''"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><b>Transferir saldo a Sistema Apple</b></h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="handleCloseModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body mt-4">
          <p>Monto a transferir (Maximo SC${{ maxPayment.toFixed(2) }})</p>
          <input
            type="number"
            class="form-control"
            v-model="input.payment"
            placeholder="Monto a transferir"
            aria-describedby="emailHelp"
            v-on:input="handleChangePayment"
          />
        </div>
        <div class="p-3 d-flex justify-content-between">
          <span class="btn btn-secondary mr-2" @click="handleCloseModal"
            >Volver</span
          >
          <span
            class="btn btn-treid"
            @click="handleClickSend"
            :class="onLoad ? 'd-none' : ''"
            >Transferir</span
          >
          <span
            class="btn btn-treid align-items-center"
            :class="onLoad ? 'd-flex' : 'd-none'"
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span class="pl-2">Transfiriendo...</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api2 from "@/tools/Api2";

export default {
  name: "ModalTransactionPayment",
  props: {
    visible: Boolean,
    maxPayment: Number,
  },
  data() {
    return {
      onLoad: false,
      input: {
        payment: 0,
      },
    };
  },
  methods: {
    handleChangePayment() {
      if (this.input.payment > this.maxPayment)
        this.input.payment = this.maxPayment.toFixed(2);
      if (this.input.payment < 0) this.input.payment = 0;
    },
    handleCloseModal() {
      this.$emit("close");
    },
    handleClickSend() {
      if (this.input.payment > 0) {
        this.onLoad = true;
        Api2("transaction")
          .post({ payment: this.input.payment, name: "APPLE_TRANSACTION" })
          .then((res) => {
            this.onLoad = false;
            this.$emit("trasnfer", {payment: this.input.payment, success: res.transactions.success});
          });
      }
    },
  },
};
</script>
<style lang="css" scoped>
</style>